<template>
  <div class="allcon">
    <el-container>
      <el-header v-if="cWidth > 1024">
        <!-- logo -->
        <div class="logoCon">
          <div class="w1200">
            <div class="logoCon_left">
              <img src="../assets/img/logo_mini.jpg" alt="" />
            </div>
            <div class="logoCon_right">
              <a style="float: left; margin-top: 0.7rem">
                <span class="iconfont icon-weixin"></span>
                <div class="lxfs-dropdown">
                  <img src="../assets/img/code.jpg" alt="" />
                </div>
              </a>
              <!-- <a>
              <span class="iconfont icon-dianhua"></span>
              <div class="lxdh-dropdown">
                <div>
                  <p>办公室：<span>23316850</span></p>
                  <p>医&nbsp;&nbsp;&nbsp;疗：<span>23126381</span></p>
                  <p>康&nbsp;&nbsp;&nbsp;复：<span>23391286</span></p>
                  <p>体&nbsp;&nbsp;&nbsp;检：<span>23128023</span></p>
                  <p>疗休养：<span>15033527324</span></p>
                </div>
              </div>
            </a> -->
              <a style="margin-top: 2rem; height: 6rem">
                <p>康&nbsp;复：<span>23391286</span></p>
                <p>体&nbsp;检：<span>23128023</span></p>
              </a>
              <a style="margin-top: 2rem; height: 6rem">
                <p>疗休养：<span>15033527324</span></p>
                <p>行风投诉：<span>23114800</span></p>
              </a>
            </div>
          </div>
          <p class="top_ym">中文域名：天津市职工疗休养中心.公益</p>
        </div>
      </el-header>
      <el-header class="app_header_con" v-else>
        <div class="app_header">
          <div class="app_top_left_logo">
            <img src="../assets/img/logo_mini.jpg" alt="" srcset="" />
          </div>
          <input
            id="toggle"
            type="checkbox"
            v-model="isAppNavShow"
            @change="
              isAppNavShow = true;
              currentNav = -1;
            "
          />

          <label for="toggle" class="hamburger">
            <div class="top-bun"></div>
            <div class="meat"></div>
            <div class="bottom-bun"></div>
          </label>
          <div class="nav" v-if="isAppNavShow">
            <div class="nav-wrapper">
              <nav>
                <div class="app_nav_right_nav">
                  <ul>
                    <li @click="isAppNavShow = false">
                      <router-link :to="{ path: '/index' }">
                        <span class="reo" style="display: block">首页</span>
                      </router-link>
                    </li>
                    <li v-for="(item, index) in navList" :key="index">
                      <a @click="appNavClick(index)">
                        <span class="reo" style="display: block">{{
                          item.first
                        }}</span>
                        <span
                          class="iconfont icon-xiajiantou2-copy youjt"
                          v-if="currentNav == index"
                        ></span>
                        <span
                          class="iconfont icon-youjiantou2 youjt"
                          v-else
                        ></span>
                      </a>
                      <div class="one_nav" v-if="currentNav == index">
                        <ul>
                          <li
                            v-for="(item2, index2) in item.second"
                            :key="index2"
                            @click="isAppNavShow = false"
                          >
                            <router-link
                              :to="{
                                path: '/secondpage',
                                query: {
                                  index: index,
                                  secondindex: index2,
                                  thirdindex: '-1',
                                },
                              }"
                            >
                              <p>{{ item2.title }}</p>
                            </router-link>
                            <div class="one_second_nav" v-if="item2.children">
                              <ul>
                                <li
                                  v-for="(item3, index3) in item2.children"
                                  :key="index3"
                                  @click="isAppNavShow = false"
                                >
                                  <router-link
                                    :to="{
                                      path: '/secondpage',
                                      query: {
                                        index: index,
                                        secondindex: index2,
                                        thirdindex: index3,
                                      },
                                    }"
                                  >
                                    <p>{{ item3.title }}</p>
                                  </router-link>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </el-header>
      <el-main>
        <div class="btnTop" v-if="btnFlag" @click="backTop()"></div>
        <router-view></router-view>
      </el-main>
      <el-footer v-if="cWidth > 1024">
        <div class="footer_con">
          <div class="footer_con_top">
            <div class="w1200">
              <div class="footer_con_top_kjdh">
                <h1 class="footer_con_top_title">快捷导航</h1>
                <div>
                  <div v-for="(item1, index1) in kjdh" :key="index1">
                    <h4>{{ item1.first }}</h4>
                    <p
                      v-for="(item2, index2) in kjdh[index1].second"
                      :key="index2"
                    >
                      <router-link
                        :to="{
                          path: '/secondpage',
                          query: { index: index1, secondindex: index2 },
                        }"
                        >{{ item2.title }}</router-link
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="footer_con_top_lxfs">
                <h1 class="footer_con_top_title">联系方式</h1>
                <div>
                  <div class="footer_con_top_lxfs_text">
                    <p>
                      <span class="iconfont icon-dizhi"></span
                      >天津市和平区大理道60号
                    </p>
                    <p>
                      <span class="iconfont icon-xinfeng"></span
                      >www.tjszglxyzx.com
                    </p>
                    <p>
                      <span class="iconfont icon-24gf-network"></span
                      >www.tjszglxyzx.com
                    </p>
                    <p>
                      <span class="iconfont icon-zhong"></span
                      >天津市职工疗休养中心.公益
                    </p>
                  </div>
                  <div class="footer_con_top_lxfs_ewm">
                    <div>
                      <img src="../assets/img/code.jpg" alt="" srcset="" />
                    </div>
                    <p>扫码关注公众号</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer_con_bot">
            <div class="w1200">
              <a href="https://beian.miit.gov.cn" target="_blank"
                >津ICP备2024014064号-1</a
              >
              ,
              <a href="https://beian.miit.gov.cn" target="_blank"
                >津ICP备2024014064号-3</a
              >
            </div>
          </div>
        </div>
      </el-footer>
      <el-footer v-else>
        <div class="footer_con">
          <div class="footer_con_top">
            <div class="w1200">
              <div class="footer_con_top_lxfs">
                <h1 class="footer_con_top_title">联系方式</h1>
                <div>
                  <div class="footer_con_top_lxfs_text">
                    <p>
                      <span class="iconfont icon-dizhi"></span
                      >天津市和平区大理道60号
                    </p>
                    <!-- <p>
                      <span class="iconfont icon-dianhua-01"></span>022-23126361
                    </p> -->
                    <p>
                      <span class="iconfont icon-xinfeng"></span
                      >www.tjszglxyzx.com
                    </p>
                    <p>
                      <span class="iconfont icon-24gf-network"></span
                      >www.tjszglxyzx.com
                    </p>
                    <p>
                      <span class="iconfont icon-zhong"></span
                      >天津市职工疗休养中心.公益
                    </p>
                  </div>
                  <div class="footer_con_top_lxfs_ewm">
                    <div>
                      <img src="../assets/img/code.jpg" alt="" srcset="" />
                    </div>
                    <p>扫码关注公众号</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer_con_bot">
            <div class="w1200">
              <a href="https://beian.miit.gov.cn" target="_blank"
                >津ICP备2024014064号-1</a
              >
              ,
              <a href="https://beian.miit.gov.cn" target="_blank"
                >津ICP备2024014064号-3</a
              >
            </div>
            <!-- 备 ********* 津公网安备*********号 -->
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "Home",
  data() {
    return {
      cWidth: sessionStorage.getItem("clientWidth"),
      btnFlag: false,
      kjdh: [],
      isAppNavShow: false,
      currentNav: -1,
      navList: [],
    };
  },
  created() {
    this.navList = this.NavList;
    this.kjdh = this.NavList;
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop, true);
  },
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 监听回到顶部按钮距浏览器顶部的距离，滚动的距离如果大于浏览器高度时，设置 btnFlag 为true,否则就是false
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      // console.log(scrollTop);
      if (scrollTop == 0) {
        $(".el-header").css("box-shadow", "none");
        // $("nav").css({
        //   background: "rgba(0, 0, 0, 0.2)",
        //   color: "#fff",
        // });
        // $("nav li>a").css({
        //   color: "#fff",
        // });
      } else {
        // $("nav").css({
        //   background: "#0182ac",
        // });
        // $(".el-header").css(
        //   "box-shadow",
        //   "0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04)"
        // );
      }
      //为了计算距离顶部的高度，当高度大于50显示回顶部图标，小于50则隐藏
      if (that.scrollTop > 50) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    // 移动端判断
    appNavClick(index) {
      if (this.currentNav != index) {
        this.currentNav = index;
      } else {
        this.currentNav = -1;
      }
    },
  },
};
</script>
<style>
/* 顶部 */
.el-header {
  /* min-width: 1200px; */
  /* width: 100vw; */
  padding: 0px !important;
  height: 8rem !important;
  display: flex;
  flex-wrap: wrap;
  /* position: fixed; */
  /* z-index: 9999; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
}
.logoCon {
  width: 100%;
  height: 8rem;
  background: #fff;
  border-bottom: 0.35rem solid #0182ac;
  box-sizing: border-box;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.09);
  position: relative;
  /* box-shadow: 0 5px #0182ac inset; */
}
.logoCon > div {
  /* width: 1000px; */
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.logoCon_left {
  /* line-height: 70px; */
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-left: 5rem;
}
.logoCon_left > img {
  height: 4.5rem;
  vertical-align: middle;
}
/* 微信下拉框 */
.logoCon_right {
  margin-right: 1rem;
}
.logoCon_right > a {
  display: inline-block;
  height: 7.6rem;
  line-height: 7.6rem;
  position: relative;
  /* margin: 0 1rem; */
  margin-left: 1rem;
}

.logoCon_right > a > span {
  font-size: 2rem;
  color: #0182ac;
  cursor: pointer;
}
.logoCon_right > a > p {
  font-size: 1.3rem;
  /* display: inline-block; */
  padding-top: 0.1rem;
  margin-left: 1rem;
  line-height: 2rem;
  color: #333;
}
.logoCon_right > a > p > span {
  color: #0182ac;
}
/* 下拉框 */
.lxfs-dropdown,
.lxdh-dropdown {
  width: 8.6rem;
  height: 8.6rem;
  position: absolute;
  top: calc(100%);
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
  z-index: 99;
  display: none;
  cursor: pointer;
  animation: elseShow 0.5s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background: #fff;
}
.lxfs-dropdown,
.lxdh-dropdown {
  display: none;
}

.lxfs-dropdown:hover,
.lxdh-dropdown:hover {
  display: block;
}

@keyframes elseShow {
  0% {
    height: 3.6rem;
  }

  100% {
    height: 8.6rem;
  }
}

.lxfs-dropdown > img {
  /* padding: 10px; */
  width: 100%;
  box-sizing: border-box;
  animation: elseShow 0.5s ease;
}

@keyframes elseShow2 {
  0% {
    height: 3.6rem;
  }
  100% {
    height: 14.6rem;
  }
}
.logoCon_right > a:hover .lxfs-dropdown,
.logoCon_right > a:hover .lxdh-dropdown,
.logoCon_right > a:hover .lxdh-dropdown > div,
.lxdh-dropdown > div:hover .lxdh-dropdown p {
  display: block;
}
.lxdh-dropdown {
  width: 16rem;
  height: 14.6rem;
  /* display: block; */
  animation: elseShow2 0.7s ease;
}
.lxdh-dropdown > div {
  padding: 1rem 0;
  box-sizing: border-box;
  height: 100%;
  display: none;
  animation: elseShow2 1s ease;
  overflow: hidden;
}
.lxdh-dropdown > div > p {
  width: 12.4rem;
  margin: 0 1.8rem;
  height: 2.5rem;
  line-height: 2.5rem;
  font-size: 1.2rem;
}
.lxdh-dropdown > div > p > span {
  color: #0179a1;
  font-size: 1.22rem;
}
.btnTop {
  max-width: 60px;
  /* max-height: 60px; */
  width: 3.5rem;
  height: 3.5rem;
  /* height: 10rem; */
  /* background: #303b68; */
  position: fixed;
  right: 2rem;
  z-index: 99;
  bottom: 3rem;
  background: url(../assets/img/top.png) no-repeat center;
  background-size: cover;
  cursor: pointer;
}

.el-main {
  /* overflow: hidden !important; */
  /* margin-top: 58rem; */
  background-color: #ffffff;
  color: #333;
  padding: 0 !important;
  overflow: hidden !important;
}

/* 底部 */
.el-footer {
  width: 100%;
  /* height: 500px !important; */
  height: 38rem !important;
  padding: 0 !important;
  background: #0182ac;
}
.footer_con {
  width: 100%;
  height: 100%;
  font-size: 1.05rem;
  color: #ffffff;
  font-weight: normal;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.footer_con_top {
  width: 100%;
  height: calc(100% - 4rem);
}
.footer_con_top > div {
  width: 79%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 3.3rem;
  height: 100%;
}
.footer_con_top > div > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
}
.footer_con_top_title {
  letter-spacing: 0.3rem;
  font-size: 1.7rem;
  margin-bottom: -0.3rem;
}
.footer_con_top_kjdh {
  width: 67%;
}
.footer_con_top_kjdh > div {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.footer_con_top_kjdh > div > div {
  width: 12.5%;
  margin-right: 1.1%;
}
.footer_con_top_kjdh > div > div > h4 {
  margin-top: 20px;
}
.footer_con_top_kjdh > div > div > p {
  font-weight: 300;
  margin: 1rem 0;
  cursor: pointer;
}
.footer_con_top_kjdh a {
  color: #fff;
  text-decoration: none;
}
.footer_con_top_kjdh a:hover {
  color: rgb(41, 177, 211);
}
.footer_con_top_lxfs {
  width: 33%;
}
.footer_con_top_lxfs > div {
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: nowrap;
}
.footer_con_top_lxfs_text > p {
  font-weight: 300;
  margin: 1.5rem 0;
}
.footer_con_top_lxfs_text > p > span {
  font-size: 1.2rem;
  margin-right: 0.5rem;
  vertical-align: middle;
}
.footer_con_top_lxfs_ewm {
  margin-top: 1.7rem;
  text-align: center;
  font-size: 0.9rem;
  margin-left: 3.5rem;
}
.footer_con_top_lxfs_ewm > div {
  width: 7.2rem;
  height: 8rem;
}
.footer_con_top_lxfs_ewm > div > img {
  width: 100%;
}
.footer_con_top_lxfs_ewm > p {
  margin-top: 0.5rem;
  font-weight: 300;
}
.footer_con_bot {
  width: 100%;
  height: 4rem;
  font-size: 1rem;
  border-top: 1px solid #ffffff9a;
  box-sizing: border-box;
  text-align: center;
  line-height: 4rem;
}
.footer_con_bot > div > a {
  color: #ffffff;
}
.footer_con_bot > div > a:hover {
  color: #b4ecff;
}
/* 顶部域名 */
.top_ym {
  position: absolute;
  bottom: 0.5rem;
  color: #0182ac;
  right: 1rem;
  font-size: 1.1rem;
  font-weight: 300;
}
</style>
